import { useEffect } from 'react';

const GA_MEASUREMENT_ID = 'G-JH22ZH1D06';

export function useGoogleAnalytics() {
  useEffect(() => {
    // Skip if user has not consented to analytics cookies
    if (localStorage.getItem('cookie_consent') !== 'accepted') {
      return;
    }

    // Skip if already initialized
    if (window.gtag) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);

  }, []);
}
